import Vue from 'vue'
import App from './App'
import router from './router/route'
import ElementUI, {
  Message
} from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
import Vuex from 'vuex'
import VueResource from 'vue-resource'
import mixins from './mixins'
import store from './store'
import './assets/icons/iconfont.css'
import './assets/css/basic.scss'
import '@/assets/css/ele-customer.scss'
import 'viewerjs/dist/viewer.css'
import ImageViewer from 'v-viewer'
import {
  bootstrap
} from './lib/http'
import {
  getCustomCookie
} from '@/xhr/_utils'
bootstrap()

Vue.use(ImageViewer, {
  name: 'thedefaultimageviewer',
  defaultOptions: {
    zIndex: 9999,
  },
})

Vue.use(VueResource)

Vue.http.interceptors.push((request, next) => {
  request.headers.set('customCookie', getCustomCookie())
  next(response => {
    if (response.status !== 200) {
      Message.error('服务当前不可用。')
    } else if (response.data.code === 401) {
      let message =
        response.status === 401 ? '身份认证已过期，请重新登录' : '会话失效，请重新登录'
      Message.error(message)
      setTimeout(() => {
        localStorage.clear()
        sessionStorage.clear()
        router.push({
          path: '/login'
        })
      }, 1200)
    } else if (response.data.code === 403) {
      Message.warning('当前用户无权限执行此操作')
    } else if (response.data.code !== 200) {
      // code为非200的时候 报错信息
      console.error(response.url, response.body.message)
    }
    return response
  })
})

Vue.use(Vuex)
Vue.use(ElementUI)
Vue.mixin(mixins)
/* eslint-disable no-new */
export default new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  },
  http: {
    root: '//testapi.sayyoo.cn/',
  },
  data: {
    // 空的实例放到根组件下，所有的子组件都能调用
    appoint: new Vue(), // 监听预约的盒子
    contract: new Vue(),
    reserveHouse: new Vue(),
    task: new Vue(),
    lease: new Vue(),
    payDetail: new Vue(),
    changeRentForm: new Vue(),
    huanRentForm: new Vue(),
    bus: new Vue(), // 公用数据通讯
  },
})



// WEBPACK FOOTER //
// ./src/main.js